import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUser } from '../../context/UserContext';
import { useSelectedOrganization } from '../../hooks/useSelectedOrganization';

const OrganizationSettings = ({ userOrganizationId }) => {
  const { isAdmin, isLoading: isUserLoading } = useUser();
  const navigate = useNavigate();
  const activeOrganizationId = useSelectedOrganization(userOrganizationId);

  useEffect(() => {
    if (!isUserLoading) {
      if (!isAdmin()) {
        navigate('/dashboard');
      } else if (activeOrganizationId) {
        // Redirect to the OrganizationEditor for the current organization
        navigate(`/settings/organization/${activeOrganizationId}`, { replace: true });
      }
    }
  }, [isAdmin, isUserLoading, navigate, activeOrganizationId]);

  // Show loading while redirecting
  return (
    <div className="settings-page">
      <div className="settings-page-header">
        <div className="settings-page-header-left">
          <h1 className="settings-page-title">Organization Settings</h1>
          <p className="settings-page-subtitle">Redirecting...</p>
        </div>
      </div>
      <div className="settings-page-content">
        <div className="settings-card">
          <div className="settings-loading">Loading...</div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationSettings;
